{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izvēlēties vienumu",
  "tableResizer": "Izmēra mainītājs",
  "colorSwatchPicker": "Color swatches"
}
